
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1650510445025",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "3989",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "width": "200",
    "height": "200"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "path",
      "attrsMap": {
        "d": "M856.27 841.14H167.73c-11.84 0-21.44 9.6-21.44 21.44v30.26c0 11.84 9.6 21.44 21.44 21.44h688.54c11.84 0 21.44-9.6 21.44-21.44v-30.26c0-11.84-9.6-21.44-21.44-21.44z m3.11-731.43H164.62c-30.32 0-54.9 24.58-54.9 54.9V713.1c0 30.32 24.58 54.9 54.9 54.9h694.76c30.32 0 54.9-24.58 54.9-54.9V164.62c0.01-30.33-24.57-54.91-54.9-54.91z m-530.24 512c0 20.2-16.37 36.57-36.57 36.57S256 641.9 256 621.71V475.43c0-20.2 16.37-36.57 36.57-36.57s36.57 16.37 36.57 36.57v146.28z m146.29 0c0 20.2-16.37 36.57-36.57 36.57s-36.57-16.38-36.57-36.57V256c0-20.2 16.37-36.57 36.57-36.57s36.57 16.37 36.57 36.57v365.71z m146.28 0c0 20.2-16.37 36.57-36.57 36.57s-36.57-16.38-36.57-36.57v-73.14c0-20.2 16.37-36.57 36.57-36.57s36.57 16.37 36.57 36.57v73.14z m146.29 0c0 20.2-16.37 36.57-36.57 36.57s-36.57-16.38-36.57-36.57V329.14c0-20.2 16.37-36.57 36.57-36.57S768 308.94 768 329.14v292.57z",
        "fill": "#ffffff",
        "p-id": "3990"
      }
    }
  ]
})
    }
  